import { useAws } from "src/networking/aws";
import {
  AwsGateCallbacks,
  AwsGateRequest,
  GetCap,
  GetMunicipalities,
  GetProvinces,
} from "src/types";

export const useGetProvinces = <
  T extends GetProvinces["request"],
  D extends GetProvinces["response"]
>() => {
  const hook = useAws<T, D>("getProvinces");

  return {
    ...hook,
    crossGate: (request: AwsGateRequest<T>, callbacks: AwsGateCallbacks<D>) => {
      return hook.crossGate(
        {
          method: "get",
          path: `/viario/province?codiceNazione=${request.queryParams.codiceNazione}`,
          ...request,
        },
        callbacks
      );
    },
  };
};

export const useGetMunicipalities = <
  T extends GetMunicipalities["request"],
  D extends GetMunicipalities["response"]
>() => {
  const hook = useAws<T, D>("getMunicipalities");

  return {
    ...hook,
    crossGate: (request: AwsGateRequest<T>, callbacks: AwsGateCallbacks<D>) => {
      return hook.crossGate(
        {
          method: "get",
          path: `/viario/comuni?codiceNazione=${request.queryParams.codiceNazione}&codiceProvincia=${request.queryParams.codiceProvincia}`,
          ...request,
        },
        callbacks
      );
    },
  };
};

export const useGetCap = <
  T extends GetCap["request"],
  D extends GetCap["response"]
>() => {
  const hook = useAws<T, D>("getCap");

  return {
    ...hook,
    crossGate: (request: AwsGateRequest<T>, callbacks: AwsGateCallbacks<D>) => {
      return hook.crossGate(
        {
          method: "get",
          path: `/viario/cap?codiceNazione=${request.queryParams.codiceNazione}&codiceProvincia=${request.queryParams.codiceProvincia}&codiceComune=${request.queryParams.codiceComune}`,
          ...request,
        },
        callbacks
      );
    },
  };
};
